export default __webpack_public_path__ + "static/media/Archpriest's Coils of the Underworld.0385b570.jpg";